<mat-card>
  <div class="d-flex">
    <!-- Profile Picture -->
    <div>
      <img src="https://picsum.photos/55" class="tl-profile">
    </div>
    <!-- Name -->
    <div>
      <div class="tl-name">John Doe
        <span class="tl-username text-success">@johndoe</span>
      </div>
      <!-- Published Date -->
      <div class="tl-date">
        <i class="fas fa-clock mr-1"></i>
        <span>1 Minute ago</span>
      </div>
    </div>
    <div class="ml-auto">
      <button mat-icon-button aria-label="Echo" matTooltip="Echoed" matTooltipPosition="before">
        <mat-icon>cached</mat-icon>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="actions">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actions="matMenu">
        <button mat-menu-item>
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
        <button mat-menu-item>
          <mat-icon>report_problem</mat-icon>
          <span>Report</span>
        </button>
        <button mat-menu-item *ngIf="false">
          <mat-icon>share</mat-icon>
          <span>Share</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <mat-card style="margin-bottom: 0;">
    <div class="d-flex">
      <!-- Profile Picture -->
      <div>
        <img src="https://picsum.photos/55" class="tl-profile">
      </div>
      <!-- Name -->
      <div>
        <div class="tl-name">Mary Jane
          <span class="tl-username text-success">@maryjane</span>
        </div>
        <!-- Published Date -->
        <div class="tl-date">
          <i class="fas fa-clock mr-1"></i>
          <span>1 Minute ago</span>
        </div>
      </div>
    </div>
    <!-- Post Content -->
    <div class="">
      <h5 class="tl-title">Conditional Post Title - For Blog Posts Only</h5>
      <p class="tl-post">
        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem
        aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
      </p>
    </div>
    <!-- Reactions Sections -->
  </mat-card>
  <div class="d-flex justify-content-between tl-reactions">
    <div>
      <button mat-icon-button aria-label="Comment" matTooltip="Comment">
        <mat-icon>comment</mat-icon>
      </button>
      <small>0</small>
      <button mat-icon-button aria-label="Favorite" matTooltip="Favorite">
        <mat-icon>favorite_border</mat-icon>
      </button>
      <small>19</small>
      <button mat-icon-button aria-label="Echo" matTooltip="Echo">
        <mat-icon>cached</mat-icon>
      </button>
      <small>7</small>
    </div>
    <div>
      <button mat-icon-button aria-label="Upvote" color="primary" matTooltip="Upvote" matTooltipPosition="above">
        <mat-icon>expand_less</mat-icon>
      </button>
      <small>-5</small>
      <button mat-icon-button aria-label="Downvote" color="accent" matTooltip="Downvote" matTooltipPosition="above">
        <mat-icon>expand_more</mat-icon>
      </button>
    </div>
  </div>
</mat-card>


<!--another design test-->

<quill-editor [(ngModel)]="content" [modules]="modules"></quill-editor>


<mat-card>
  <div class="d-flex">
    <!-- Profile Picture -->
    <div>
      <img src="https://picsum.photos/55" class="tl-profile">
    </div>
    <!-- Name -->
    <div>
      <div class="tl-name">Home Fiber
        <span class="tl-username text-success">@homefb</span>
      </div>
      <!-- Published Date -->
      <div class="tl-date">
        <i class="fas fa-clock mr-1"></i>
        <span>1 Minute ago</span>
      </div>
    </div>
    <div class="ml-auto">
      <button mat-icon-button [matMenuTriggerFor]="actions">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actions="matMenu">
        <button mat-menu-item>
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
        <button mat-menu-item>
          <mat-icon>report_problem</mat-icon>
          <span>Report</span>
        </button>
        <button mat-menu-item *ngIf="false">
          <mat-icon>share</mat-icon>
          <span>Share</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <!-- Post Content -->
  <div class="border-bottom">
    <!-- <h5 class="tl-title">Conditional Post Title - For Blog Posts Only</h5> -->
    <p class="tl-post">
      This is my question??
    </p>
    <!-- Poll -->
    <!-- On CLick It Should Display Poll Results -->
    <div class="tl-poll-vote">
      <mat-radio-group aria-label="Select an option" class="tl-poll-group">
        <mat-radio-button value="1" class="tl-poll-button">Option 1</mat-radio-button>
        <mat-radio-button value="2" class="tl-poll-button">Option 2</mat-radio-button>
      </mat-radio-group>
    </div>
    <!-- Poll Results - To Be Activated by Voting -->
    <div class="tl-poll-results">
      <div class="d-flex tl-poll">
        <span class="tl-poll-percentage">47%</span>
        <div class="tl-poll-bar">
          <span class="tl-poll-option">Option One</span>
          <mat-progress-bar mode="determinate" value="47" class="tl-poll-display"></mat-progress-bar>
        </div>
        <span matTooltip="You voted for this" matTooltipPosition="before"><i class="fa fa-check-circle"
                                                                             aria-hidden="true"></i></span>
      </div>
      <!-- Duplicate -->
      <div class="d-flex tl-poll">
        <span class="tl-poll-percentage">20%</span>
        <div class="tl-poll-bar">
          <span class="tl-poll-option">Option Two</span>
          <mat-progress-bar mode="determinate" value="20" class="tl-poll-display"></mat-progress-bar>
        </div>
      </div>
      <!-- Duplicate -->
      <div class="d-flex tl-poll">
        <span class="tl-poll-percentage">33%</span>
        <div class="tl-poll-bar">
          <span class="tl-poll-option">Option Two</span>
          <mat-progress-bar mode="determinate" value="33" class="tl-poll-display"></mat-progress-bar>
        </div>
      </div>
    </div>
    <div class="tl-poll-meta">
      <i class="fas fa-users mr-1"></i>
      <span>513 Votes</span>
      <i class="fas fa-stopwatch mr-1 ml-1"></i>
      <span>23 hrs left</span>
    </div>
  </div>
  <!-- Reactions Sections -->
  <div class="d-flex justify-content-between tl-reactions">
    <div>
      <button mat-icon-button aria-label="Comment" matTooltip="Comment">
        <mat-icon>comment</mat-icon>
      </button>
      <small>0</small>
      <button mat-icon-button aria-label="Favorite" matTooltip="Favorite">
        <mat-icon>favorite_border</mat-icon>
      </button>
      <small>19</small>
      <button mat-icon-button aria-label="Echo" matTooltip="Echo">
        <mat-icon>cached</mat-icon>
      </button>
      <small>7</small>
    </div>
    <div>
      <button mat-icon-button aria-label="Upvote" color="primary" matTooltip="Upvote" matTooltipPosition="above">
        <mat-icon>expand_less</mat-icon>
      </button>
      <small>-5</small>
      <button mat-icon-button aria-label="Downvote" color="accent" matTooltip="Downvote" matTooltipPosition="above">
        <mat-icon>expand_more</mat-icon>
      </button>
    </div>
  </div>
</mat-card>




